module.exports = __webpack_public_path__ + "img/propertysupervise1.d04ffac1.png";